import axios from '../api/axiosInstance';
import { API_ENDPOINTS } from '../api/apiEndpoints';

/**
 * @param {string} applicationId Focus 360 application_id (Mongo)
 * @param {string} dateFrom YYYY-MM-DD
 * @param {string} dateTo YYYY-MM-DD
 */
export async function fetchUsage(applicationId, dateFrom, dateTo) {
  const response = await axios.get(API_ENDPOINTS.usage, {
    params: {
      application_id: applicationId,
      from: `${dateFrom}T00:00:00Z`,
      to: `${dateTo}T23:59:59Z`,
    },
  });
  return response.data;
}
